import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const AreaChart = ({ revenueData }) => {
 
  const formatRevenueData = (data) => {
    if (!data) return [];
    return Object.values(data).map(value => {
    
      const numValue = parseFloat(value);
      return parseFloat(numValue.toFixed(2));
    });
  };

  const [chartOptions, setChartOptions] = useState({
    series: [
      {
        name: "Revenue",
        data: formatRevenueData(revenueData),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: revenueData ? Object.keys(revenueData) : [],
        title: {
          text: "",
        },
      },
      yaxis: {
        title: {
          text: "Revenue",
        },
        labels: {
          formatter: function(value) {
            return parseFloat(value).toFixed(2);
          }
        }
      },
      legend: {
        position: "top",
      },
    },
  });

  useEffect(() => {
    setChartOptions((prevOptions) => ({
      ...prevOptions,
      series: [
        {
          name: "Revenue",
          data: formatRevenueData(revenueData),
        },
      ],
      options: {
        ...prevOptions.options,
        xaxis: {
          categories: revenueData ? Object.keys(revenueData) : [],
        },
      },
    }));
  }, [revenueData]);

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type="bar"
          height={350}
        />
      </div>
    </div>
  );
};

export default AreaChart;









// import React, { useEffect, useState } from "react";
// import ReactApexChart from "react-apexcharts";
// // Mock data for series

// const AreaChart = ({ revenueData, filter }) => {
//   let series = {
//     monthDataSeries1: {
//       prices: revenueData ? Object.values(revenueData) : [],
//       dates: revenueData ? Object.keys(revenueData) : [],
//     },
//   };
  
//   const [chartOptions, setChartOptions] = useState({
//     series: [
//       {
//         name: "Revenue",
//         data: series.monthDataSeries1.prices,
//       },
//     ],
//     options: {
//       chart: {
//         type: "area",
//         height: 350,
//         zoom: {
//           enabled: false,
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         curve: "straight",
//       },
//       labels: series.monthDataSeries1.dates,
//       // xaxis: {
//       //   type: "datetime",
//       //   // labels: {
//       //   //   formatter: function (value) {
//       //   //     const date = new Date(value);
//       //   //     return date.toLocaleDateString("en-US", { weekday: "short" });
//       //   //   },
//       //   // },
//       //   // labels: value,
//       // },
//       yaxis: {
//         opposite: false,
//       },
//       legend: {
//         horizontalAlign: "left",
//       },
//       chart: {
//         toolbar: {
//           show: false
//         }
//       },
//     },
//   });

//   useEffect(() => {
//     let updatedSeries = {
//       monthDataSeries1: {
//         prices: revenueData ? Object.values(revenueData) : [],
//         dates: revenueData ? Object.keys(revenueData) : [],
//       },
//     };

//     setChartOptions((prevOptions) => ({
//       ...prevOptions,
//       series: [
//         {
//           name: "Revenue",
//           data: updatedSeries.monthDataSeries1.prices,
//         },
//       ],
//       options: {
//         ...prevOptions.options,
//         labels: updatedSeries.monthDataSeries1.dates,
//         xaxis: {
//           ...prevOptions.options.xaxis,
//         },
//       },
//     }));
//   }, [revenueData]);


//   return (
//     <div>
//       <div id="chart">
//         <ReactApexChart
//           options={chartOptions.options}
//           series={chartOptions.series}
//           type="area"
//           height={350}
//         />
//       </div>
//       <div id="html-dist"></div>
//     </div>
//   );
// };

// export default AreaChart;
